// uiHandler.js
var UiHandler = pc.createScript('uiHandler');

UiHandler.attributes.add('startButton', {type: 'entity'});

UiHandler.attributes.add('landScape', {
    type: 'entity'
});
UiHandler.attributes.add('portrait', {
    type: 'entity'
});
UiHandler.attributes.add('textCharts', {
    type: 'entity',
    array: true
});
UiHandler.attributes.add('fadeEnt', {
    type: 'entity'
});

UiHandler.attributes.add('logos', {
    type:'entity'});

UiHandler.attributes.add('vrButton', {
    type:'entity'});

UiHandler.attributes.add('xrMessage', {
    type:'entity'});

UiHandler.attributes.add('soundButton', {
    type:'entity'});

UiHandler.attributes.add('syncLoop', {
    type:'entity'});

UiHandler.attributes.add('syncObjects', {
    type:'entity'});

UiHandler.attributes.add('uiElements', {
    type:'entity'});

// initialize code called once per entity
UiHandler.prototype.initialize = function() {
    
    that = this;

    this.syncLoopScript = this.syncLoop.script.soundSync;
    this.bPressed = false;
    this.firsTime = true;
    this.contentVisible = false;
    this.tween = false;
    this.counter = 0;
    this.preCounter = 0;
    this.currentScreen = null;
    this.resize = false;
    this.direction = 0;
    this.showEnt = null;
    this.preEnt = null;
    this.callbackCounter = 0;
    this.soundSwitch = true;
    this.oneTimeSound = true;
    this.vrTweenBlock = false;
    
    var startRatio = this.app.graphicsDevice.width / this.app.graphicsDevice.height;
    //this.app.on('start', this.introAnim, this);

    this.app.graphicsDevice.on('resizecanvas', function(width, height) {
        var ratio = width / height;
        if(that.contentVisible){
            that.resize = true;
            that.hideAndShow();
            that.showText(ratio);
        }

    });
    
    this.app.on('buttonPressed', this.buttonPressed, this);
    this.app.on('setBack', this.setBack, this);
    this.app.on('touch:swipedMenu', this.buttonPressed, this);
    this.app.on('xrMessage:out', this.xrOut, this);

    // ******** TOUCH ********

    UiHandler.wasDragged = false;
    UiHandler.firstX = 0;
    UiHandler.firstY = 0;
    UiHandler.deltaX = 0;
    UiHandler.deltaY = 0;
    UiHandler.startTime = 0;
    UiHandler.elapsedTime = 0;

    UiHandler.allowedTime = 600;
    UiHandler.threshold = 50;
    UiHandler.restraint = 100;

    UiHandler.mouseMoveAllowed = false;
    UiHandler.touchArea = document.body;

    if (pc.platform.mobile) {
        UiHandler.touchArea.addEventListener('touchstart', function(e) {
            UiHandler.wasDragged = false;
            UiHandler.firstX = e.targetTouches[0].pageX;
            UiHandler.firstY = e.targetTouches[0].pageY;
            UiHandler.startTime = new Date().getTime();
        });

        UiHandler.touchArea.addEventListener('touchmove', function(e) {
            UiHandler.wasDragged = true;

            var currentX = e.targetTouches[0].pageX;
            UiHandler.deltaX = currentX - UiHandler.firstX;

            var currentY = e.targetTouches[0].pageY;
            UiHandler.deltaY = currentY - UiHandler.firstY;
        });

        UiHandler.touchArea.addEventListener('touchend', function(e) {
            UiHandler.prototype.detectSwipe();
        });

    } else if (pc.platform.desktop) {

        UiHandler.touchArea.addEventListener('mousedown', function(e) {
            UiHandler.mouseMoveAllowed = true;
            UiHandler.wasDragged = false;
            UiHandler.firstX = e.pageX;
            UiHandler.firstY = e.pageY;
            UiHandler.startTime = new Date().getTime();
        });

        UiHandler.touchArea.addEventListener('mousemove', function(e) {
            if (UiHandler.mouseMoveAllowed) {
                UiHandler.wasDragged = true;
                var currentX = e.pageX;
                UiHandler.deltaX = currentX - UiHandler.firstX;
                var currentY = e.pageY;
                UiHandler.deltaY = currentY - UiHandler.firstY;
            }
        });

        UiHandler.touchArea.addEventListener('mouseup', function(e) {
            UiHandler.prototype.detectSwipe();
            UiHandler.mouseMoveAllowed = false;
        });
    }

    // ******** TOUCH ********  
    // 
    // ******** BUTTONVR *****
        this.cameraEntity = this.app.root.findByName('VRCamera');
        this.vrButton.element.on('click', function() {
            
        var startVr = function () {
            this.uiElements.enabled = false;
            console.log('vrstarter');
            this.cameraEntity.camera.nearClip = 0.1;
            this.cameraEntity.camera.startXr(pc.XRTYPE_VR, pc.XRSPACE_LOCALFLOOR);
        }.bind(this);
        
        // check support
        if (this.app.xr.isAvailable(pc.XRTYPE_VR)) {
            // ask for motion permissions if we can
            if (window.DeviceOrientationEvent && window.DeviceOrientationEvent.requestPermission) {
                DeviceOrientationEvent.requestPermission().then(
                    function(response) {
                        if (response == 'granted') {
                            window.addEventListener('deviceorientation', function (e) {
                                // start session
                                startVr();
                            }.bind(this));
                        }
                    }.bind(this)).catch(console.error);
            } else {
                // start session
                startVr();
            }
        }
    }, this);
    
};

UiHandler.prototype.xrOut = function(){
    console.log('XROUT');
    var xrm = this.xrMessage;
    var xrPos = xrm.getLocalPosition();
    xrm.tween(xrPos).to({x: xrPos.x, y: xrPos.y-500, z: xrPos.z}, 0.25, pc.sineOut)
    .on('complete', function() {
        xrm.enabled = false;
        console.log('tweened');
        xrm.setLocalPosition(xrPos.x, xrPos.y+500, xrPos.z);
        that.fadeBlack('out',0);
        that.vrTweenBlock = false;
    })
    .delay(1.5)
    .start();
};

UiHandler.prototype.introAnim = function(){
    
    this.fadeBlack('out', 5);
    var burger = this.app.root.findByName('button_burger');
    var count_l = this.app.root.findByName('numbers_l');
    var count_r = this.app.root.findByName('numbers_r');
    var countPos_l = count_l.getLocalPosition();
    var countPos_r = count_r.getLocalPosition();
    var bPos = burger.getLocalPosition();
    var vrPos = this.vrButton.getLocalPosition();
    var tapePos = this.soundButton.getLocalPosition();
    var logPos = this.logos.getLocalPosition();
    
    this.soundButton.children[0].enabled = false;
    
    bPos.y += 300; countPos_l.y -= 300; countPos_r.y -= 300; vrPos.y +=300; tapePos.y +=300; logPos.y += 300;
    
    
    burger.tween(bPos).to({x: bPos.x, y: bPos.y - 300, z: bPos.z}, 0.3, pc.SineOut).delay(1.15).start();
    this.logos.tween(logPos).to({x: logPos.x, y: logPos.y - 300, z: logPos.z}, 0.3, pc.SineOut).delay(1).start();
    this.soundButton.tween(tapePos).to({x: tapePos.x, y: tapePos.y - 300, z: tapePos.z}, 0.3, pc.SineOut).delay(1.3).start();
    this.vrButton.tween(vrPos).to({x: vrPos.x, y: vrPos.y - 300, z: vrPos.z}, 0.3, pc.SineOut).delay(1.45).start();
    count_l.tween(countPos_l).to({x: countPos_l.x, y: countPos_l.y + 300, z: countPos_l.z}, 0.3, pc.SineOut).delay(1.15).start();
    count_r.tween(countPos_r).to({x: countPos_r.x, y: countPos_r.y + 300, z: countPos_r.z}, 0.3, pc.SineOut).delay(1.30).start();
};

UiHandler.prototype.detectSwipe = function() {

    if (!UiHandler.wasDragged) {
        return;
    }
    
    if(that.bPressed){
        return;
    }

    
    var swipedir = null;

    UiHandler.elapsedTime = new Date().getTime() - UiHandler.startTime;
    if (UiHandler.elapsedTime <= UiHandler.allowedTime) {
        if (Math.abs(UiHandler.deltaX) >= UiHandler.threshold && Math.abs(UiHandler.deltaY) <= UiHandler.restraint) {
            swipedir = (UiHandler.deltaX < 0) ? 'button_right' : 'button_left';
        } else if (Math.abs(UiHandler.deltaY) >= UiHandler.threshold && Math.abs(UiHandler.deltaX) <= UiHandler.restraint) {
            swipedir = (UiHandler.deltaY < 0) ? 'button_right' : 'button_left';
        }
    }

    if (!that.swipeTween) {
        if(that.contentVisible){
            that.app.fire('touch:swipedMenu', swipedir); // exectues swipeOrder
        }
    }
    UiHandler.firstX = 0;
    UiHandler.firstY = 0;
    UiHandler.deltaX = 0;
    UiHandler.deltaY = 0;
};

UiHandler.prototype.buttonPressed = function(bName) {
    
    if(bName == 'start'){
        this.startButton.enabled = false;
        this.syncLoopScript.startSound();
        this.introAnim();
        return;
    }   

    if(bName === null){
        return;
    }    
    this.resize = false;
    var countMax = this.textCharts.length - 1;
    var burger = this.app.root.findByName('button_burger');
    var count_l = this.app.root.findByName('numbers_l');
    var count_r = this.app.root.findByName('numbers_r');
    var countPos_l = count_l.getLocalPosition();
    var countPos_r = count_r.getLocalPosition();
    var bPos = burger.getLocalPosition();
    var vrPos = this.vrButton.getLocalPosition();
    var tapePos = this.soundButton.getLocalPosition();
    var logPos = this.logos.getLocalPosition();
    this.bPressed = false;
    
    if (!this.tween) {
        if(bName == 'button_sound'){
            if(this.oneTimeSound){
                this.syncLoopScript.loadSounds();
                this.oneTimeSound = false;
            }
            
            this.syncLoopScript.startSound();
            if(this.soundSwitch){
                this.syncObjects.enabled = true;
                this.soundButton.children[0].enabled = true;
                this.soundSwitch = false;
            } else {
                this.app.fire('stopSounds');
                this.syncObjects.enabled = false;
                this.soundButton.children[0].enabled = false;
                this.soundSwitch = true;    
            }
            return;
        }
        if(bName == 'button_VR'){
            //console.log('XRBUTTONPRESSED ' + this.app.xr.supported);
            if(!this.vrTweenBlock){
                if(!this.app.xr.isAvailable(pc.XRTYPE_VR)){
                    this.vrTweenBlock = true;
                    var xrm =  this.xrMessage;
                    xrm.enabled = true;
                    this.fadeBlack('in',0);
                    var xrPos = xrm.getLocalPosition();
                    xrm.setLocalPosition(xrPos.x, xrPos.y - 300, xrPos.z);
                    xrm.tween(xrm.getLocalPosition()).to({x: xrPos.x, y: xrPos.y + 300, z: xrPos.z}, 0.25, pc.SineOut)
                        .on('complete', function(){
                        that.app.fire('xrMessage:out');
                    })
                        .start();
                }
            }
            return;
        }
        if(bName == 'button_burger'){
            this.contentVisible = true;
            this.bPressed = true;
            if(this.firsTime){
                this.counter = 0;
                this.preCounter = countMax;
                this.firsTime = false;
            }
            var w = this.app.graphicsDevice.width;
            var h = this.app.graphicsDevice.height;
            var r = w / h;
            burger.tween(bPos).to({x: bPos.x, y: bPos.y + 300, z: bPos.z}, 0.3, pc.SineOut)
                .on('complete', function(){
                that.bPressed = false;
            })
            .delay(0.15)
            .start();
            
            this.logos.tween(logPos).to({x: logPos.x, y: logPos.y + 300, z: logPos.z}, 0.3, pc.SineOut)
                .on('complete', function(){
                that.bPressed = false;
            })
            .start();
            
            this.soundButton.tween(tapePos).to({x: tapePos.x, y: tapePos.y + 300, z: tapePos.z}, 0.3, pc.SineOut)
                .on('complete', function(){
                that.bPressed = false;
            })
            .delay(0.3)
            .start();
            
            this.vrButton.tween(vrPos).to({x: vrPos.x, y: vrPos.y + 300, z: vrPos.z}, 0.3, pc.SineOut)
                .on('complete', function(){
                that.bPressed = false;
            })
            .delay(0.45)
            .start();
            
            count_r.tween(countPos_r).to({x: countPos_r.x, y: countPos_r.y - 300, z: countPos_r.z}, 0.3, pc.SineOut)
                .on('complete', function(){
                that.bPressed = false;
            })
            .delay(0.15)
            .start();
            
            count_l.tween(countPos_l).to({x: countPos_l.x, y: countPos_l.y - 300, z: countPos_l.z}, 0.3, pc.SineOut)
                .on('complete', function(){
                that.bPressed = false;
            })
            .delay(0.30)
            .start();  
            
            this.fadeBlack('in',0);
            this.showText(r);
        }
        if (bName == 'button_x') {
            this.contentVisible = false;
            this.bPressed = true;
            
            burger.tween(bPos).to({x: bPos.x, y: bPos.y - 300, z: bPos.z}, 0.3, pc.SineOut).delay(0.15).start();
            this.logos.tween(logPos).to({x: logPos.x, y: logPos.y - 300, z: logPos.z}, 0.3, pc.SineOut).start();
            this.soundButton.tween(tapePos).to({x: tapePos.x, y: tapePos.y - 300, z: tapePos.z}, 0.3, pc.SineOut).delay(0.3).start();
            this.vrButton.tween(vrPos).to({x: vrPos.x, y: vrPos.y - 300, z: vrPos.z}, 0.3, pc.SineOut).delay(0.45).start();
            count_l.tween(countPos_l).to({x: countPos_l.x, y: countPos_l.y + 300, z: countPos_l.z}, 0.3, pc.SineOut).delay(0.15).start();
            count_r.tween(countPos_r).to({x: countPos_r.x, y: countPos_r.y + 300, z: countPos_r.z}, 0.3, pc.SineOut).delay(0.30).start();
            
            this.fadeBlack('out',0);
            this.landScape.enabled = false;
            this.portrait.enabled = false;
        } else if (bName == 'button_left') {
            this.bPressed = false;
            this.direction = -1;
            this.preCounter = this.counter;
            this.counter -= 1;
        } else if (bName == 'button_right') {
            this.bPressed = false;
            this.direction = 1;
            this.preCounter = this.counter;
            this.counter += 1;
        }

        if (this.counter > countMax) {
            this.counter = 0;
        } else if (this.counter < 0) {
            this.counter = countMax;
        }

        if(!this.bPressed){
            this.hideAndShow();
        }
    }

};

UiHandler.prototype.fadeBlack = function(dir,dly) {
    
    var s = 0;
    var e = 0;
    
    if(dir == 'in'){
        s = 0;
        e = 0.75;
    } else if(dir == 'out') {
        s = 0.75;
        e = 0;
    }
    
    var data = {opacity: s};    
    var material = this.fadeEnt.model.material;

    this.app
        .tween(data)
        .to({
            opacity: e
        }, 0.3, pc.Linear)
        .on('update', function() {
            // alpha is called opacity in Playcanvas
            material.opacity = data.opacity;
            material.update();
        })
        .delay(dly)
        .start();
};

UiHandler.prototype.hideAndShow = function() {

    for (var hide = 0; hide < this.textCharts.length; hide++) {
        var hdEnt = this.currentScreen.findByName(this.textCharts[hide].name);
        this.currentScreen.children[hide].enabled = false;
    }

    this.showEnt = this.currentScreen.findByName(this.textCharts[this.counter].name);
    this.preEnt = this.currentScreen.findByName(this.textCharts[this.preCounter].name);
    this.showEnt.enabled = true;


    if (!this.resize) {
        
        this.preEnt.enabled = true;
        this.setTween(this.showEnt, this.preEnt);
    }

};

UiHandler.prototype.setTween = function(sE, pE) {
console.log(pE.name);
    this.tween = true;
    var mMargin = this.app.graphicsDevice.width;
    var delayTime = 0.15;
    var baseTime = 0.5;

    for (var i = 0; i < sE.children.length; i++) {

        var sEnt = sE.children[i];
        var sp = sEnt.getLocalPosition();
        var sPos = new pc.Vec3(sp.x, sp.y, sp.z);

        sEnt.setLocalPosition(sPos.x + mMargin * this.direction, sPos.y, sPos.z);

        sEnt.tween(sEnt.getLocalPosition())
            .to({
                x: sPos.x,
                y: sPos.y,
                z: sPos.z
            }, baseTime + i * delayTime, pc.QuinticInOut)
            .on('complete', function() {
                //that.setBack(sE);
            })
            .start();
    }


    for (var j = 0; j < pE.children.length; j++) {

        var pEnt = pE.children[j];
        var pp = pEnt.getLocalPosition();
        var pPos = new pc.Vec3(pp.x, pp.y, pp.z);
        var shoot = false;

        pEnt.tween(pEnt.getLocalPosition())
            .to({
                x: pPos.x - mMargin * this.direction,
                y: pPos.y,
                z: pPos.z
            }, baseTime + j * delayTime, pc.QuinticInOut)
            .on('complete', function() {
                that.app.fire('setBack', pE);
            })
            .start();
    }

};

UiHandler.prototype.setBack = function(ent) {
    this.callbackCounter += 1;
    if (this.callbackCounter == ent.children.length) {
        this.tween = false;
        this.callbackCounter = 0;
    }
    var scrpt = ent.script.resetChildren;
    scrpt.resetNodes(this.direction);
};


UiHandler.prototype.showText = function(ratio) {
    var lnd = this.landScape;
    var prt = this.portrait;
    if (ratio > 0.85) {
        lnd.enabled = true;
        prt.enabled = false;
        this.currentScreen = lnd;
    } else {
        lnd.enabled = false;
        prt.enabled = true;
        this.currentScreen = prt;
    }
};

// update code called every frame
UiHandler.prototype.update = function(dt) {

};

// swap method called for script hot-reloading
// inherit your script state here
// UiHandler.prototype.swap = function(old) { };

// to learn more about script anatomy, please read:
// http://developer.playcanvas.com/en/user-manual/scripting/

